import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/system';
import useAxios from '../../hooks/useAxios';
import { collectionList, pickListTypes } from '../../types/pick';
import {
    Button,
    Grid,
    InputAdornment,
    Menu,
    MenuItem,
    OutlinedInput,
    Pagination,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography
} from '@mui/material';
import PickPageListDetail from '../pickPage/PickPageListDetail';
import { gridSpacing } from '../../store/constant';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import TransactionRow from './transaction.row';
import { TransactionListTypes } from '../../types/charity';
import { IconSearch } from '@tabler/icons';
import MainCard from '../../ui-component/cards/MainCard';

const TransactionWrapper = () => {
    const theme = useTheme();
    const { axiosService } = useAxios();
    const [listParam, setListParam] = useState<{
        skip: number;
        take: number;
        nameSort: 'ASC' | 'DESC';
        creditSort: 'ASC' | 'DESC';
    }>({
        skip: 0,
        take: 10,
        nameSort: 'ASC',
        creditSort: 'ASC'
    });
    const [paging, setPaging] = useState({
        allPage: 0,
        count: 0
    });
    const getData = async () => {
        const response = await axiosService.post('/transaction/admin/list', listParam);
        setList(response.data.list);
        setPaging((p) => ({
            ...p,
            allPage: response.data.allPage,
            count: response.data.count
        }));
    };

    useEffect(() => {
        getData();
    }, [listParam]);

    const pageChange = (event, page) => {
        setListParam((p) => ({ ...p, skip: page - 1 }));
    };
    const [list, setList] = useState<TransactionListTypes[]>([]);
    const [anchorEl, setAnchorEl] = React.useState<Element | ((element: Element) => Element) | null | undefined>(null);
    const handleClick = (event: React.MouseEvent) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <MainCard
            title={
                <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
                    <Grid item>
                        <Typography variant="h3">Transaction List</Typography>
                    </Grid>
                </Grid>
            }
            content={false}
        >
            <TableContainer>
                <Table size="small" aria-label="collapsible table">
                    <TableHead sx={{ '& th,& td': { whiteSpace: 'nowrap' } }}>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Profile</TableCell>
                            <TableCell>Amount</TableCell>
                            <TableCell>Type</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody sx={{ '& th,& td': { whiteSpace: 'nowrap' } }}>
                        {list.map((value, index: number) => (
                            <TransactionRow key={value.idx} value={value} index={index} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Grid item xs={12} sx={{ p: 3 }}>
                <Grid container justifyContent="space-between" spacing={gridSpacing}>
                    <Grid item>
                        <Pagination page={listParam.skip + 1} count={paging.allPage} color="secondary" onChange={pageChange} />
                    </Grid>
                    <Grid item>
                        <Button
                            size="large"
                            sx={{ color: theme.palette.grey[900] }}
                            color="secondary"
                            endIcon={<ExpandMoreRoundedIcon />}
                            onClick={handleClick}
                        >
                            10 Rows
                        </Button>
                        <Menu
                            id="menu-user-list"
                            // @ts-ignore
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                            variant="selectedMenu"
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right'
                            }}
                            transformOrigin={{
                                vertical: 'bottom',
                                horizontal: 'right'
                            }}
                        >
                            <MenuItem onClick={handleClose}> 10+</MenuItem>
                            <MenuItem onClick={handleClose}> 20+</MenuItem>
                            <MenuItem onClick={handleClose}> 30+</MenuItem>
                        </Menu>
                    </Grid>
                </Grid>
            </Grid>
        </MainCard>
    );
};

export default TransactionWrapper;
